module.exports = __webpack_public_path__ + "img/116.3cd2e52.jpg";